import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";
import { getMe, getAuthConfig, logout as apiLogout } from "../lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authRequired, setAuthRequired] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const cfg = await getAuthConfig();
      setAuthRequired(cfg.auth_required !== false);
      // Login disattivato: il backend restituisce l'utente team condiviso senza cookie
      setUser(await getMe());
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from OAuth callback, skip the /me check: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await apiLogout();
    } catch (e) {
      console.warn("logout request failed, clearing local session anyway", e);
    }
    setUser(null);
    window.location.href = "/login";
  }, []);

  const value = useMemo(() => ({ user, setUser, loading, authRequired, checkAuth, logout }), [user, loading, authRequired, checkAuth, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
